//==========================================================================
// contact.js - Contact Form Validation (for #contactForm / #ContactForm)
//==========================================================================

function initValidateContactForm() {
  var $form = $('#contactForm').length ? $('#contactForm') : $('#ContactForm');
  if (!$form.length) return;

  // Hard guard: nếu form invalid thì chặn submit tuyệt đối
  $form.on('submit', function (e) {
    var vld = $form.data('validator');
    if (vld && !$form.valid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  });

  $form.attr('novalidate','novalidate');
  $form.validate({
    // Đừng bỏ qua các field ẩn cho #message-body (contact[body])
    ignore: ':hidden:not(#message-body)',

    rules: {
      'last_name': {
        required: true,
        maxlength: 50
      },
      'first_name': {
        required: true,
        maxlength: 50
      },
      'h_last_name_kana': {
        katakanaOnly: true,
        maxlength: 50
      },
      'h_first_name_kana': {
        katakanaOnly: true,
        maxlength: 50
      },
      'company': {
        maxlength: 100
      },
      'phone': {
        phoneJP: true
      },
      'contact[email]': {
        required: true,
        email: true,
        maxlength: 100
      },
      'contact[email]': {
        required: true,
        email: true,
        maxlength: 100
      },
       'mess': {
        required: true,
        maxlength: 400
      },
      // Validate TRƯỜNG GỬI LÊN SHOPIFY
      'contact[body]': {
        required: true,
      }
    },

    messages: {
      last_name: {
        required: "姓を入力してください。",
        maxlength: "姓は50文字以内で入力してください。"
      },
      'first_name': {
        required: "名を入力してください。",
        maxlength: "名は50文字以内で入力してください。"
      },
      'h_last_name_kana': {
        katakanaOnly: "姓（カナ）は全角カタカナで入力してください。",
        maxlength: "姓（カナ）は50文字以内で入力してください。"
      },
      'h_first_name_kana': {
        katakanaOnly: "名（カナ）は全角カタカナで入力してください。",
        maxlength: "名（カナ）は50文字以内で入力してください。"
      },
      'company': {
        maxlength: "会社名は100文字以内で入力してください。"
      },
      'phone': {
        phoneJP: "電話番号は正しい形式で入力してください。"
      },
      'contact[email]': {
        required: "メールアドレスを入力してください。",
        email: "正しいメールアドレスの形式で入力してください。",
        maxlength: "メールアドレスは100文字以内で入力してください。"
      },
      'contact[body]': {
        required: "お問い合わせ内容を入力してください。",
        maxlength: "お問い合わせ内容は400文字以内で入力してください。"
      },
     'mess': {
        required: "お問い合わせ内容を入力してください。",
        maxlength: "お問い合わせ内容は400文字以内で入力してください。"
      }
    },

    errorPlacement: function(error, element) {
      error.addClass('c-form__error');
      error.insertAfter(element);
    },
    highlight: function(element) {
      $(element).addClass('c-form__input--error');
    },
    unhighlight: function(element) {
      $(element).removeClass('c-form__input--error');
    },

    // Khi HỢP LỆ mới chạy vào đây
    submitHandler: function(form) {
      const $submit = $(form).find('button[type="submit"]');
      const originalText = $submit.find('.c-btn__detail-txt').text();
      $submit.prop('disabled', true);
      $submit.find('.c-btn__detail-txt').text('送信中...');
      form.submit();
    }
  });
}

/* =========================
   Custom validation methods
   ========================= */
$.validator.addMethod("katakanaOnly", function(value, element) {
  if (this.optional(element)) return true;
  return /^[ァ-ヶー\s]+$/.test(value);
}, "全角カタカナで入力してください。");

$.validator.addMethod("phoneJP", function(value, element) {
  if (this.optional(element) || value === '') return true;
  const digits = value.replace(/-/g, '');
  return /^(0[1-9]\d{8,9}|0[5789]0\d{8})$/.test(digits);
}, "正しい電話番号を入力してください。");

/* =========================
   Realtime UX helpers
   ========================= */
function initContactRealtime() {
  $('#phone').on('input', function() {
    let v = $(this).val().replace(/[^\d-]/g, '');
    $(this).val(v);
    const vld = $("#contactForm").data('validator') || $("#ContactForm").data('validator');
    if (vld) vld.element(this);
  });

  $('#h_last_name_kana, #h_first_name_kana').on('input', function() {
    const ok = /^[ァ-ヶー\s]*$/.test($(this).val());
    $(this).toggleClass('c-form__input--warning', !ok);
  });
}

/* =========================
   Boot
   ========================= */
$(function () {
  initValidateContactForm();
  initContactRealtime();
});
